import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import { DataContextProvider } from './DataContextProvider';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
     <React.StrictMode>
      <DataContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </DataContextProvider>
    </React.StrictMode>
  ); 


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
